// Meta Pixel + cookie consent. The pixel is only loaded after the visitor
// accepts; until then (or if they decline) no Meta script is requested.
const PIXEL_ID = '2277689509707110';
const CONSENT_KEY = 'dl-cookie-consent';

export function getConsent() {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
}

export function setConsent(value) {
  try { localStorage.setItem(CONSENT_KEY, value); } catch { /* storage blocked */ }
}

export function loadPixel() {
  if (typeof window === 'undefined' || window.fbq) return;
  const n = window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);
  window.fbq('init', PIXEL_ID);
  // The route open when consent was given (admin pages are never reported).
  if (!window.location.pathname.startsWith('/admin')) window.fbq('track', 'PageView');
}

// Safe no-op when the pixel isn't loaded (no consent, or blocked).
export function trackPixel(event, params, { custom = false } = {}) {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;
  window.fbq(custom ? 'trackCustom' : 'track', event, params);
}
